import React from 'react';
import { Link } from 'react-router-dom';

import Keyboard from '../Keyboard/index';
import HiresCards from '../HiresCards/index';
import './styles.scss';

function Hires () {
  return (

    <div className="hires__container">
      <div className="hires__header__container">
        <div className="hires__call__to">
          <div className="hires__title__container">
            <h2 className="hires__header__title">internet <span>inigualable</span></h2>
            <h3 className="hires__header__subtitle"><span>tv</span> interactiva + telefonía fija</h3>
          </div>
          <div className="hires__header__price__container">
            <h3 className="hires__header__price">desde <span>$499</span> al mes</h3>
          </div>
          <button className="hires__header__button">
            <Link to="/popup" className="button__link">lo quiero</Link>
          </button>
        </div>
        <div className="hires__now__container">
          <div className="hires__now__title">
            <h3>¡contrata ahora!</h3>
          </div>
          <div className="hires__now__content">
            <h4>Déjanos tu número y</h4>
            <h4>te llamamos en segundos</h4>
            <p>si es celular sin el 044 ó 045.</p>
            <input className="hires__input" placeholder="Tu teléfono"></input>
            <div className="hires__privacy">
              <input type="checkbox" id="hires__privacy__text" name="hires__privacy__text" />
              <label className="hires__privacy__text" for="hires__privacy__text">He leído y acepto las políticas de privacidad.</label>
            </div>
            <button className="hides__call__button">
              <Link to="/popup" className="button__link">llámame</Link>
            </button>
          </div>
        </div>
      </div>
      <Keyboard />
      <HiresCards />
    </div>
  );
}

export default Hires;
